import { useEffect, useState } from 'react';

const AnimatedHighlights = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('animated-highlights');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const highlights = [
    {
      icon: 'ri-fish-line',
      title: '釣りテクニック',
      description: '初心者から上級者まで、様々な釣りテクニックを詳しく解説',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'アクアリウム',
      description: '美しい水槽の作り方とメンテナンス方法をご紹介',
      color: 'from-teal-500 to-green-500'
    },
    {
      icon: 'ri-tools-line',
      title: '道具レビュー',
      description: '最新の釣り具やアクアリウム用品の詳細なレビュー',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-book-open-line',
      title: '知識とヒント',
      description: '魚の行動や生態系についての深い知識を共有',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section id="animated-highlights" className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            私たちの特徴
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            釣りとアクアリウムの世界を深く探求するための豊富なコンテンツ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className={`group relative transition-all duration-700 transform ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100">
                {/* Animated Background Gradient */}
                <div className={`absolute inset-0 bg-gradient-to-br ${highlight.color} opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
                
                {/* Icon Container */}
                <div className="relative mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-br ${highlight.color} rounded-xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-500 shadow-lg`}>
                    <i className={`${highlight.icon} text-3xl text-white`}></i>
                  </div>
                  {/* Floating Animation Circle */}
                  <div className={`absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-br ${highlight.color} rounded-full opacity-20 group-hover:scale-150 transition-transform duration-700`}></div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-teal-500 group-hover:to-teal-600 transition-all duration-300">
                  {highlight.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {highlight.description}
                </p>

                {/* Hover Arrow */}
                <div className="mt-4 flex items-center text-teal-500 opacity-0 group-hover:opacity-100 transform translate-x-0 group-hover:translate-x-2 transition-all duration-300">
                  <span className="text-sm font-medium whitespace-nowrap">詳しく見る</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AnimatedHighlights;
